import React from 'react';
import { Media, UnitValue } from '../../types';
import { Container } from './styles';

export type SizeType = UnitValue | Media<UnitValue> | undefined;

export interface Props {
  size?: SizeType;
  color?: string;
}

export function Preloader({ size = 40, ...props }: Props) {
  return (
    <Container size={size} {...props}>
      <svg fill="none" viewBox="0 0 44 44" stroke="currentColor" strokeWidth={2} aria-hidden="true">
        <circle cx={22} cy={22} r={20} />
        <circle cx={22} cy={22} r={20} />
      </svg>
    </Container>
  );
}
